import React from 'react';
import {
	CargoContractSides,
	CargoUnitSingularLabels,
	EstimateStatus,
	FreightRateType,
	QuantityOptions,
} from '@shared/utils/constants';
import { formatCurrency } from '@shared/utils/currency';
import type { EditableCargo } from '@api/features/cargos/updateCargo';
import EmptyText from '@client/components/EmptyText';
import { EditableDetailsItem } from '@client/components/EditableField';

export const getCargoDetailsFields = ({
	cargoDetails,
}: {
	cargoDetails: EditableCargo;
}) => {
	const addonAfterFreightRate = cargoDetails.freightType === FreightRateType.PER_UNIT ?
		`/ ${CargoUnitSingularLabels[cargoDetails.unit]}` :
		'';
	const disabled = cargoDetails?.status === EstimateStatus.Fixed && cargoDetails.voyageId == null;

	return (
		[
			{
				key: 'addressCommission',
				label: 'Address Commission',
				value: cargoDetails.addressCommission,
				type: 'percentage',
				editable: !disabled,
			},
			{
				key: 'quantityTolerance',
				label: 'Quantity Tolerance',
				value: cargoDetails.quantityTolerance,
				type: 'percentage',
				editable: !disabled,
				inputProps: {
					disabled: cargoDetails.contractSide === CargoContractSides.VC_IN,
				},
			},
			{
				key: 'quantityOption',
				label: 'Quantity Option',
				type: 'select',
				value: cargoDetails.quantityOption,
				options: Object.values(QuantityOptions).map((c) => ({
					label: QuantityOptions[c],
					value: c,
				})),
				inputProps: {
					placeholder: 'Select Option',
					showSearch: true,
					disabled: cargoDetails.contractSide === CargoContractSides.VC_IN,
				},
				render: () => (
					<>
						{cargoDetails.quantityOption != null ?
							QuantityOptions[cargoDetails.quantityOption] : (<EmptyText />)}
					</>
				),
				editable: !disabled,
			},
			{
				key: 'overageAmount',
				label: 'Overage Rate',
				type: 'currency',
				value: cargoDetails.overageAmount,
				inputProps: {
					currency: cargoDetails.currency,
				},
				editable: !disabled,
				render: () => (
					<>
						{cargoDetails.overageAmount != null ?
							`${formatCurrency(cargoDetails.overageAmount, cargoDetails.currency)}
									${addonAfterFreightRate}
								` : (<EmptyText />)}
					</>
				),
			},
			{
				key: 'deadfreightAmount',
				label: 'Deadfreight Rate',
				type: 'currency',
				value: cargoDetails.deadfreightAmount,
				inputProps: {
					currency: cargoDetails.currency,
				},
				editable: !disabled,
				render: () => (
					<>
						{cargoDetails.deadfreightAmount != null ?
							`${formatCurrency(cargoDetails.deadfreightAmount, cargoDetails.currency)}
										${addonAfterFreightRate}` : (<EmptyText />)}
					</>
				),
			},

		] as EditableDetailsItem<any>[]
	);
};
